export const NOTFOUND_CSS = `
  .nf-page {
    min-height: 100vh;
    background: var(--color-ivory);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 24px;
    position: relative;
    overflow: hidden;
    text-align: center;
  }

  /* Background texture */
  .nf-page::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse 70% 50% at 50% 0%, rgba(31,111,95,0.06) 0%, transparent 60%),
      radial-gradient(ellipse 50% 40% at 80% 100%, rgba(201,165,106,0.05) 0%, transparent 60%);
    pointer-events: none;
  }

  .nf-inner {
    position: relative;
    z-index: 1;
    max-width: 560px;
  }

  .nf-code {
    font-family: var(--font-serif);
    font-size: clamp(7rem, 18vw, 12rem);
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.02em;
    color: transparent;
    -webkit-text-stroke: 1px rgba(31,111,95,0.25);
    margin-bottom: 0;
    user-select: none;
  }

  .nf-divider {
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: center;
    margin: 8px 0 32px;
  }

  .nf-divider-line {
    width: 48px;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(201,165,106,0.4));
  }
  .nf-divider-line:last-child {
    background: linear-gradient(to left, transparent, rgba(201,165,106,0.4));
  }

  .nf-divider-diamond {
    width: 5px;
    height: 5px;
    background: var(--color-gold);
    transform: rotate(45deg);
    opacity: 0.6;
  }

  .nf-eyebrow {
    font-family: var(--font-sans);
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: var(--color-gold);
    margin-bottom: 16px;
    display: block;
  }

  .nf-title {
    font-family: var(--font-serif);
    font-size: clamp(1.6rem, 4vw, 2.4rem);
    font-weight: 300;
    color: var(--color-charcoal);
    margin-bottom: 16px;
    line-height: 1.2;
  }

  .nf-desc {
    font-family: var(--font-sans);
    font-size: 15px;
    font-weight: 300;
    color: var(--color-slate);
    line-height: 1.7;
    margin-bottom: 40px;
  }

  .nf-actions {
    display: flex;
    gap: 16px;
    justify-content: center;
    flex-wrap: wrap;
  }
`
